/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Empty_Personal_BodyInputs */



/**
* | output |
* | --- |
* | "Ask Wundo in the chat to practise a conversation. The practice conversation it makes for that appears here." |
*
* @param {Practice_Empty_Personal_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_empty_personal_body = /** @type {((inputs?: Practice_Empty_Personal_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Empty_Personal_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vraag Wundo in de chat om een gesprek te oefenen. Het oefengesprek dat hij daarvoor maakt, verschijnt hier.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demandez à Wundo dans le chat de préparer un entretien. L'entretien d'entraînement qu'il crée apparaît ici.")
	return /** @type {LocalizedString} */ ("Ask Wundo in the chat to practise a conversation. The practice conversation it makes for that appears here.")
});